var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('CasusBibendi',{attrs:{"casus":_vm.current}}),_c('router-link',{staticClass:"back",attrs:{"to":"/"}},[_vm._v("← Vissza az összes okhoz")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }